export interface Pillar {
  icon: string;
  title: string;
  desc: string;
}
/* desc: 'Fight creatures, NPCs, and PCs; solve puzzles, and have other experiences that appear in the real world through your phone. Track HP, use skills, and earn XP and loot.', */
export const pillars: ReadonlyArray<Pillar> = [
  {
    icon: '/assets/pillars-icon-location.png',
    title: 'Real-World Quests',
    desc: 'Quests unfold at actual locations using augmented reality to immerse you in the game world. Navigate a city, involve yourself in the narrative, solve puzzles, and uncover hidden lore.',
  },
  {
    icon: '/assets/pillars-icon-mechanics.png',
    title: 'TTRPG Game Mechanics',
    desc: 'Rolling dice, combat turns, narrative-based role play — all the mechanics you love, in the palm of your hand.',
  },
  {
    icon: '/assets/pillars-icon-tools.png',
    title: 'Creator Toolsets',
    desc: 'Use the Game Master Interface to build Quests and our Homebrew platform to contribute your creativity in the form of creatures, items, skills, spells, and more!',
  },
];
